/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_EmailInputs */



/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Settings_EmailInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_email = /** @type {((inputs?: Settings_EmailInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_EmailInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("E-mailadres")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse e-mail")
	return /** @type {LocalizedString} */ ("Email address")
});